<template>
  <div class="left-box">
    <div class="item" >
      <div class="item-header">
        <el-select v-model="form.way" style="width: 206px">
          <el-option label="承诺达标合格证数据" value="way"></el-option>
          <el-option label="合格证开具数据汇总" value="way1"></el-option>
          <el-option label="合格证开具数量品种排行" value="way2"></el-option>
          <el-option label="合格证地区开具数量占比" value="way3"></el-option>
        </el-select>
      </div>
      <div class="item-content"  v-if="form.way == 'way' && baseInfo">
          <div class="fx-column" style="width:100%">
            <div class="content-box">
              <div class="item-content-child" v-for="item in keys" :key="item.value">
                <img src="@/assets/imgs/base/1.png" />
                <div class="item-content-child-info">
                  <span>{{item.label}}</span>
                  <div>{{baseInfo[item.value]}}</div>
                </div>
              </div>
            </div>
            <div class="bar-box" id="bar-box5"></div>
          </div>
      </div>
      <!-- 双折线图 -->
      <div
        class="item-content"
        v-if="form.way == 'way1'"
        id="lineElement"
      ></div>
      <!-- 柱状图 -->
      <div class="item-content" v-if="form.way == 'way2'" id="barElement"></div>
      <!-- 柱状图 -->
      <div class="item-content" v-if="form.way == 'way3'" id="pieElement"></div>
    </div>
    <div class="item">
      <div class="item-header">
        <!-- 网络化监管排名 -->
      </div>
      <div class="item-content">
        <div class="item-rank-header">
          <div>排名</div>
          <div>单位</div>
          <div>巡逻次数</div>
        </div>
        <div class="item-rank" v-for="item in rankList" :key="item.seq">
          <div class="start">
            <span>{{item.seq}}</span>
            <div>{{item.name}}</div>
          </div>
          <div>{{item.agency}}</div>
          <div>{{item.times||0}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import indexMins from "@/mixins/left.js";
import {request_get} from "@/utils/request.js"
export default {
  name: "LeftBox",
  mixins: [indexMins],
  data() {
    return {
      form: {
        way: "way",
      },
      checkCity:null,
      metadata:null,
      baseInfo:null,
      rankList:[],
      listData:{},
      keys:[{
        value:"all",
        label:"开具总数"
      },{
        value:"today",
        label:"今日开具"
      },{
        value:"clazz",
        label:"农产品品种"
      }]
    };
  },
  props:{
    cityInfo:{
      type:Object,
      default:()=>{}
    }
  },
  async mounted() {
    this.checkCity = this.cityInfo
    await this.getMetadata();
    await this.getRankList();
    
    if (this.form.way == "way1") {
      if (this.myChart1) {
        this.myChart1.dispose();
      }
      if(this.pieChat) {
        this.pieChat.dispose();
      }
      this.initLine2(document.getElementById("lineElement"),this.metadata);
    } else if (this.form.way == "way2") {
      if (this.barChart) {
        this.barChart.dispose();
      }
      if(this.pieChat) {
        this.pieChat.dispose();
      }
      this.initBar(document.getElementById("barElement"),this.metadata);
    }else if(this.form.way == "way3"){
      if (this.myChart1) {
              this.myChart1.dispose();
            }
          if (this.barChart) {
              this.barChart.dispose();
            }
          this.$nextTick(function() {
            this.initPieChart(document.getElementById("pieElement"),this.metadata)
          })

    }else {
       if (this.barChart) {
        this.barChart.dispose();
      }
      if (this.myChart) {
        this.myChart.dispose();
      }
      if (this.myChart1) {
        this.myChart1.dispose();
      }
      if(this.pieChat) {
        this.pieChat.dispose();
      }
      if(this.barChart9) {
            this.barChart9.dispose();
          }
      // this.rightBar9(document.getElementById("bar-box5"))
    }
  },
  watch: {
    form: {
      handler(val) {
        if (val.way == "way1") {
          if (this.barChart) {
              this.barChart.dispose();
            }
            if(this.pieChat) {
              this.pieChat.dispose();
            }
          this.$nextTick(function () {
            this.initLine2(document.getElementById("lineElement"),this.metadata);
          });
        } else if (val.way == "way2") {
          if (this.myChart1) {
              this.myChart1.dispose();
            }
            if(this.pieChat) {
              this.pieChat.dispose();
            }
          this.$nextTick(function () {
            this.initBar(document.getElementById("barElement"),this.metadata);
          });
        }else if(val.way == "way3") {
          if (this.myChart1) {
              this.myChart1.dispose();
            }
          if (this.barChart) {
              this.barChart.dispose();
            }
          this.$nextTick(function() {
            this.initPieChart(document.getElementById("pieElement"),this.metadata)
          })
        }else {
           if (this.barChart) {
              this.barChart.dispose();
            }
            if (this.myChart) {
              this.myChart.dispose();
            }
            if (this.myChart1) {
              this.myChart1.dispose();
            }
            if(this.pieChat) {
            this.pieChat.dispose();
          }
          if(this.barChart9) {
            this.barChart9.dispose();
          }
          this.$nextTick(function() {
            this.rightBar9(document.getElementById("bar-box5"),this.listData)
          })
        }
      },
      deep: true,
    },
    cityInfo:{
      handler:function (data) { 
        this.checkCity = data;
      },
      deep: true,
    }
  },
  methods:{
    // 获取监测数据
    getDeletionData2() {
            request_get("/lsd/index/detectionSamplingCount",{area:this.currentInfo?.name},res => {
                if(res.code == 200) {
                    this.listData = res.data||{};
                    this.rightBar9(document.getElementById("bar-box5"),this.listData)
                }
            })
        },
    getMetadata() {
      request_get("/lsd/index/productionCertificateCount",{area:this.checkCity?.name},res => {
        if(res.code == 200) {
          this.metadata = res.data;
          this.baseInfo = res.data.info||null;
          this.getDeletionData2()
          // this.rightBar9(document.getElementById("bar-box5"))
        }
      })
    },
    // 获取监管排名
    getRankList() {
      request_get("/lsd/index/rankingList",{},res => {
        if(res.code == 200) {
          this.rankList = res.data;
        }
      })
    },
  }
};
</script>
<style lang="scss">
.item-header {
  .el-select,
  .el-input__inner {
    width: 206px !important;
  }
}
</style>
<style lang="scss" scoped>
.left-box {
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  background: linear-gradient(270deg, rgba(37, 106, 191, 0.1) 0%, #031a37 100%);

  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 20px 40px 20px;
  
    box-sizing: border-box;

    &:nth-of-type(2) {
      .item-content {
        flex-direction: column !important;
      }
    }

    .item-header {
      height: 54px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background: url("../../assets/imgs/left-top-1.png") no-repeat;
      background-size: 100% 100%;
    }

    &:nth-of-type(2) {
      .item-header {
        background: url("../../assets/imgs/left-top-2.png") no-repeat;
      }
    }

    .item-content {
      flex: 1;
      display: flex;
      padding-top: 40px;
      flex-wrap: wrap;
      box-sizing: border-box;

      &-child {
        display: flex;
        width: 33.3%;
        box-sizing: border-box;

        img {
          width: 58px;
          height: 66px;
        }

        &-info {
          display: flex;
          flex-direction: column;
          margin-left: 12px;

          span {
            color: white;
            font-size: 16px;
            margin-bottom: 5px;
          }

          div {
            background: linear-gradient(
              90deg,
              #043c3d 0%,
              rgba(24, 70, 118, 0) 100%
            );
            min-height: 36px;
            font-size: 22px;
            font-weight: bold;
            color: white;
            padding: 5px 10px;
            box-sizing: border-box;
          }
        }
      }

      //网络化监管排名
      .item-rank-header,
      .item-rank {
        width: 100%;
        display: flex;

        align-items: center;
        color: white;
        padding: 0 24px;
        margin-bottom: 4px;
        background: linear-gradient(
          90deg,
          rgba(0, 20, 28, 0.3) 0%,
          rgba(1, 32, 45, 0.3) 50%,
          rgba(0, 20, 28, 0.3) 100%
        );
        box-sizing: border-box;

        div {
          flex: 3;
          text-align: center;

          &:nth-of-type(1),
          &:nth-of-type(3) {
            flex: 1;
          }

          &:nth-of-type(3) {
            text-align: right;
          }
        }
      }

      .item-rank-header {
        height: 24px;

        &:nth-of-type(1) {
          text-align: center !important;
        }
      }

      .item-rank {
        padding: 6px 24px;
        max-height: 37px;

        box-sizing: border-box;

        div {
          &:nth-of-type(3) {
            color: rgba(4, 215, 234, 1);
            font-size: 24px;
            font-weight: bold;
            padding-right: 20px;
            box-sizing: border-box;
          }
        }
        &:nth-of-type(3) {
          .start {
            span {
              border-color: rgba(241, 91, 51, 1) !important;
              color: rgba(255, 157, 131, 1) !important;
              background: rgba(126, 33, 9, 0.6) !important;
            }
          }
        }
        &:nth-of-type(4) {
          .start {
            span {
              border-color: rgba(43, 181, 88, 1) !important;
              color: rgba(16, 253, 123, 1) !important;
              background: rgba(23, 83, 43, 0.6) !important;
            }
          }
        }
      }

      .start {
        display: flex;
        align-items: center;

        span {
          border-radius: 50%;
          background: rgba(89, 61, 0, 0.6);
          width: 30px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          color: #fbe600;
          border: 1px solid #e4a703;
        }

        div {
          color: #d7eff9;
          font-size: 16px;
        }
      }
      .start_2 {
        display: flex;
        align-items: center;
        div {
          color: #d7eff9;
          font-size: 16px;
          &:nth-of-type(1) {
            width: 26px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background: linear-gradient(#011924 0%, #075253 100%);
            border: 1px solid rgba(152, 238, 253, 1);
            color: rgba(215, 239, 249, 1);
          }
        }
      }
    }
  }

  .fx-column{
    display: flex;
    flex-direction: column;
    .content-box{
      display: flex;
    }
      .bar-box{
        width:100%;
        height:220px;
    }
  }
}
</style>
